export const FORM_STATUS = Object.freeze({
  IDLE: "idle",
  SUCCESS: "success",
  ERROR: "error",
});